import styled from '@emotion/styled';

import { RotateGradientBanner } from '@/components/discount-code/rotateGradientBanner/style';

export const Banner = styled(RotateGradientBanner)``;
